import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "shell" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "search-form-item" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = {
  key: 0,
  class: "search-form-item"
}
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = { class: "search-form-item" }
const _hoisted_8 = {
  key: 1,
  class: "search-form-item"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "flex1 display-flex justify-content-end"
}
const _hoisted_11 = {
  key: 3,
  class: "flex1 display-flex justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_add_button = _resolveComponent("add-button")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_set_didstibutor_dialog = _resolveComponent("set-didstibutor-dialog")
  const _component_kitDialog = _resolveComponent("kitDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_secondary_nav, {
      navs: _ctx.secondMenus,
      active: _ctx.activeNavItem,
      onChoose: _ctx.changePath
    }, null, 8, ["navs", "active", "onChoose"]),
    _createVNode("div", _hoisted_2, [
      (_ctx.activeNavItem==='property')
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_3, [
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$wordList.ProperAllTextInstaller), 1),
              _createVNode(_component_cus_select, {
                onChange: _ctx.changeInstaller,
                modelValue: _ctx.listRequestData.param.InstallerId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listRequestData.param.InstallerId = $event)),
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_cus_option, {
                    value: "all",
                    label: _ctx.$wordList.SelectAll
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.installerOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.ID,
                      value: item.ID,
                      label: item.Name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onChange", "modelValue"])
            ]),
            (_ctx.listRequestData.param.InstallerId !== 'all')
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$wordList.ProperAllTextProject), 1),
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.listRequestData.param.ProjectId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.ProjectId = $event)),
                    filter: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cus_option, {
                        value: "all",
                        label: _ctx.$wordList.SelectAll
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.communityOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item.ID,
                          value: item.ID,
                          label: item.Name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.listRequestData.param.searchValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listRequestData.param.searchValue = $event)),
                placeholder: _ctx.$wordList.TabelPropertyManageEmail
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.activeNavItem!=='property')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_el_input, {
              class: "width400px",
              modelValue: _ctx.searchValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchValue = $event))
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.searchKey,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchKey = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item,
                        value: item.name,
                        label: item.label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_cus_button, {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateToList++))
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
        ]),
        _: 1
      }),
      (_ctx.type === 'distributor')
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode(_component_cus_button, {
              onClick: _ctx.goMacLibrary,
              class: "margin-right10px"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.NavInHtmlMenuMacLibrary), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_add_button, { onClick: _ctx.addDistributor }, null, 8, ["onClick"])
          ]))
        : (_ctx.type === 'endUser')
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode(_component_cus_button, {
                class: "margin-right10px",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowKit = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextImportKitEndUser), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_list_pagination, {
      headers: _ctx.headers,
      requestData: _ctx.listRequestData,
      update: _ctx.updateToList,
      showDefaultAction: _ctx.defaultAction,
      deleteUrl: _ctx.deleteUrl,
      action: _ctx.action,
      showCheck: false,
      onEdit: _ctx.editDistributor,
      onInfo: _ctx.goInfo,
      onGoToDevice: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goMacLibrary($event.ID)))
    }, {
      ProjectSlot: _withCtx((data) => [
        _createVNode("div", {
          class: "max-width400px text-overflow",
          title: data.scope.Project
        }, _toDisplayString(data.scope.Project), 9, ["title"])
      ]),
      _: 1
    }, 8, ["headers", "requestData", "update", "showDefaultAction", "deleteUrl", "action", "onEdit", "onInfo"]),
    (_ctx.isShowDisDialog)
      ? (_openBlock(), _createBlock(_component_set_didstibutor_dialog, {
          key: 0,
          operaType: _ctx.disDialogOperaType,
          initForm: _ctx.formData,
          onSuccess: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateToList++)),
          onClose: _ctx.closeDisDialog
        }, null, 8, ["operaType", "initForm", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isShowKit)
      ? (_openBlock(), _createBlock(_component_kitDialog, {
          key: 1,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowKit = false))
        }))
      : _createCommentVNode("", true)
  ]))
}